<wiz-hgroup
  #actionContainer
  width="100%"
  height="100%"
  verticalAlign="center"
  style="padding: 5px"
  class="shadowed">
  <wiz-icon #btnConf *ngIf="isInContentList()" (click)="showConf()">settings</wiz-icon>
  <wiz-label [wizLabel]="data.labelOrDefaultLabel" [ngClass]="dataClass()" width="100%"></wiz-label>

  <wiz-icon *ngIf="isUsed()" class="image-inactive">icon-see</wiz-icon>
  <wiz-icon #iconRemove *ngIf="isInContentList()" (click)="doDelete()">delete</wiz-icon>

</wiz-hgroup>
